import React, { useState } from "react";
import styles from "./styles";
import multipleSelection from "../../../../images/multipleSelection.svg";
import correctIcon from "../../../../images/correct.svg";
import globeIcon from "../../../../images/globeIcon.svg";
import flagIcon from "../../../../images/flagIcon.svg";
import NotQuiteIcon from "../../../../images/notQuite.svg";
import IncorrectIcon from "../../../../images/incorrect.svg";
import { Grid, Typography, Button } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import "animate.css/animate.css";
import { isMobile } from "react-device-detect";

const BreakingNews = ({
  questionAnswer,
  answeredCorrectly,
  answeredPartialy,
  submitted,
  questionIndex,
  selectedOption,
  setSelectedOption,
  animation,
  setAnimation,
  classes,
}) => {
  const animationBlock = () => {
    return (
      <Grid className={classes.animationAnswerContainer}>
        <Grid
          className={classes.animationQuestionBody}
        >
          <Grid>
            <Typography className={classes.animationQuestion}>
              U.S. t-shirt makers successfully lobby the government to put a
              tariff on t-shirts.
            </Typography>
          </Grid>

          <Typography variant="h4" className={classes.animationAnswerText}>
            The graph shows how the market looks like now.
          </Typography>
        </Grid>
        <Button
          onClick={() => setAnimation(false)}
          className={classes.nextButton}
        >
          OK
        </Button>
      </Grid>
    );
  };

  if (animation && questionIndex === 2) {
    return animationBlock();
  }

  return (
    <>
      <Grid style={{ display: submitted ? "none" : "block" }}>
        {!questionAnswer.options ? (
          <>
            <Grid className={classes.questionContainer}>
              <Grid className={classes.questionHeader}>
                {questionAnswer.type === "international" ? (
                  <img
                    src={globeIcon}
                    className={classes.headerIcon}
                    alt=""
                  ></img>
                ) : (
                  <img
                    src={flagIcon}
                    className={classes.headerIcon}
                    alt=""
                  ></img>
                )}
                <Typography
                  varient="h5"
                  className={`${classes.headerText} ${
                    (questionIndex === 3 || questionIndex === 10) &&
                    "animate__animated animate__bounceIn"
                  }`}
                >
                  {isMobile
                    ? questionAnswer.mobileHeader
                    : questionAnswer.header}
                </Typography>
              </Grid>

              <Grid className={classes.questionBody}>
                <img
                  src={questionAnswer.icon}
                  className={classes.circleIcon}
                  alt=""
                />
                <Grid style={{ display: submitted ? "none" : "block" }}>
                  <Typography
                    className={
                      questionAnswer.type === "international" ||
                      questionAnswer.type === "international2"
                        ? classes.internationalQuestionDescription
                        : classes.domesticQuestionDescription
                    }
                    dangerouslySetInnerHTML={{ __html: questionAnswer.text }}
                  ></Typography>
                </Grid>
                <Grid
                  style={{ display: submitted ? "none" : "block" }}
                  className={classes.questionTextDiv}
                >
                  <Typography
                    variant="h5"
                    className={`${classes.questionText} animate__animated animate__bounceIn`}
                    style={{ fontWeight: 600, color: "#00b1d9" }}
                  >
                    Select the
                  </Typography>
                  <Typography
                    variant="h5"
                    className={`${classes.questionTextMajor} animate__animated animate__bounceIn`}
                  >
                    {questionAnswer.question}
                  </Typography>
                  <Typography
                    variant="h5"
                    className={`${classes.questionText} animate__animated animate__bounceIn`}
                    style={{ fontWeight: 600, color: "#00b1d9" }}
                  >
                    area on the graph
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <img
              src={multipleSelection}
              className={classes.breakingNews}
              alt=""
            ></img>
          </>
        ) : (
          <Grid className={classes.optionQuestionContainer}>
            <Typography
              varient="h5"
              className={`${classes.optionQuestion} animate__animated animate__bounceIn`}
            >
              {questionAnswer.text}
            </Typography>
            <Grid className={classes.optionQuestionBody}>
              {questionAnswer.options.map((option, i) => (
                <Typography
                  varient="h3"
                  style={{
                    color: selectedOption === i ? "#fff" : "#003E4C",
                    backgroundColor:
                      selectedOption === i ? "#003E4C" : "#ecf2f1",
                  }}
                  className={classes.optionChoices}
                  onClick={() => setSelectedOption(i)}
                >
                  {option}
                </Typography>
              ))}
            </Grid>
          </Grid>
        )}
      </Grid>

      <Grid
        className={classes.answerContainer}
        style={{ display: submitted ? "block" : "none" }}
      >
        <Grid>
          <Grid className={classes.questionBody}>
            <Grid>
              <Typography className={classes.answerDescription}>
                {questionAnswer.answerTextTop}
              </Typography>
              {!questionAnswer.options && (
                <Typography className={classes.answerDescription}>
                  Select the {questionAnswer.question} area on the graph.
                </Typography>
              )}
            </Grid>

            {answeredCorrectly ? (
              <img
                src={correctIcon}
                className={classes.correctIncorrectIcon}
                alt=""
              />
            ) : answeredPartialy ? (
              <>
                <img
                  src={NotQuiteIcon}
                  className={classes.correctIncorrectIcon}
                  alt=""
                />

                <Typography variant="h4" className={classes.noQuiteText}>
                  {questionAnswer.notQuiteText}
                </Typography>
              </>
            ) : (
              answeredCorrectly === false && (
                <img
                  src={IncorrectIcon}
                  className={classes.correctIncorrectIcon}
                  // style={{ fontSize: 22, marginTop: 25, marginBottom: 25 }}
                  alt=""
                />
              )
            )}
            <Typography
              variant="h4"
              className={classes.answerText}
              dangerouslySetInnerHTML={{ __html: questionAnswer.answerText }}
            ></Typography>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default withStyles(styles)(BreakingNews);
